import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

interface ErrorGiftCardProps {
  message?: string;
}

const ErrorGiftCardSection = ({
  message = 'An error occurred while loading gift card information. Please try again later.',
}: ErrorGiftCardProps) => {
  const { whmcs_id: whmcsId } = useParams();
  const navigate = useNavigate();
  return (
    <div className="min-h-[50vh] w-full flex items-center justify-center p-4">
      <div className="w-full max-w-md flex flex-col items-center justify-center p-6 space-y-4 bg-white rounded-lg shadow-sm border border-red-100">
        <div className="p-3 bg-red-50 rounded-full">
          <AlertCircle className="w-8 h-8 text-red-500" />
        </div>

        <div className="text-center space-y-2">
          <h3 className="text-lg font-semibold text-gray-900">Error</h3>
          <p className="text-sm text-gray-600">{message}</p>
        </div>

        <Button
          onClick={() => {
            navigate(`/${whmcsId}`);
          }}
          variant="outline"
        >
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default ErrorGiftCardSection;
